import axios from "axios";

const PLAN_URL = '/rest/tariffs/ga/list/item';
const PLAN_LIST_URL = '/rest/tariffs/ga/list/index';

export const obtainPlan = async (category, variant, eventName) => {
    let plan = await planRequest(category, variant);
    const currency = plan['currency'];

    delete plan['currency'];

    return {
        'event': eventName,
        'ecommerce': {
            'currency': currency,
            'value': plan['price'],
            'items': [plan]
        }
    };
};

export const obtainPlanList = async () => {
    const planList = await planListRequest();

    return {
        'event': 'view_item_list',
        'ecommerce': {
            'items': planList
        }
    };
};

const planRequest = (category, variant) => {
    return axios.get(PLAN_URL, {
        params: {
            category: category,
            variant: variant,
        }
    })
        .then((response) => {
            return response.data.data;
        });
};

const planListRequest = () => {
    return axios.get(PLAN_LIST_URL)
        .then((response) => {
            return response.data.data;
        });
};